__turbopack_context__.v({
  "bookACallButton": "style-module-scss-module__tKr3IW__bookACallButton",
  "bottomWrapper": "style-module-scss-module__tKr3IW__bottomWrapper",
  "copy": "style-module-scss-module__tKr3IW__copy",
  "formWrapper": "style-module-scss-module__tKr3IW__formWrapper",
  "glowWrapper": "style-module-scss-module__tKr3IW__glowWrapper",
  "industriesLobbyPage": "style-module-scss-module__tKr3IW__industriesLobbyPage",
  "leftSide": "style-module-scss-module__tKr3IW__leftSide",
  "mediaList": "style-module-scss-module__tKr3IW__mediaList",
  "navContainer": "style-module-scss-module__tKr3IW__navContainer",
  "navList": "style-module-scss-module__tKr3IW__navList",
  "rightSide": "style-module-scss-module__tKr3IW__rightSide",
  "title": "style-module-scss-module__tKr3IW__title",
  "wrapper": "style-module-scss-module__tKr3IW__wrapper",
});
